module.exports = __webpack_public_path__ + "img/gill5.eeb2bafe.svg";